import {
  Component,
  Input,
  OnInit,
  output,
  ChangeDetectionStrategy
} from '@angular/core';
import { JkBaseComponent } from '../jkbase/jkbase.component';
//import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // 新增這行
import {
  MatCheckboxModule,
} from '@angular/material/checkbox';
import { jkLib } from '../../services/jkCommon';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-jkcheckboxYN',
  templateUrl: './jkcheckboxYN.component.html',
  styleUrls: ['./jkcheckbox.component.css'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FormsModule, // 新增這行
    //BrowserAnimationsModule, // 新增這行
    MatCheckboxModule,
  ],
})
export class JkcheckboxYNComponent extends JkBaseComponent implements OnInit {
  override comType: string = 'jkcheckboxYN';
  //private _value: boolean = false;
  _value: boolean = false;
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() set valueYN(value: string) {
    this._value = value === 'Y';
  }

  get valueYN(): string {
    return this._value ? 'Y' : 'N';
  }

  readonly valueYNChange = output<string>();

  onCheckboxChange(event: any) {
    this._value = event.checked;
    this.valueYNChange.emit(this.valueYN);
  }
  constructor() {
    super();
  }

  override ngOnInit() {
    super.ngOnInit();
  }
  addWhere(where: string,fieldName:string): string {
      where = jkLib.yn2Where(this.valueYN, where, fieldName);
      return where;
  }
}
